import styled from 'styled-components';

import Card from 'components/common/Card';
import Link from 'components/common/Link';
import Text from 'components/common/Text';

interface IProps {
  following?: boolean;
  mr?: number;
  mb?: number;
  ml?: number;
  fw?: number;
  isClickable?: boolean;
}

export const PostPageLinkPostWrapper = styled(Card)`
  margin: 0 0 16px;
  max-width: 550px;
  width: 100%;
`;

export const MediaWrapper = styled.div<IProps>`
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'auto')};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const LinkImageWrapper = styled.div`
  width: 100%;
`;

export const LinkWrap = styled(Link)`
  display: block;
  cursor: pointer;
  text-decoration: none;
  width: 100% !important;
`;

export const LinkImageBackground = styled.div`
  max-height: 366px;
  & > span {
    width: 100% !important;
  }
`;

export const LinkBlockWrap = styled.div`
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  border-right: 1px solid ${(props) => props.theme.colors.neutral.n2};
  border-left: 1px solid ${(props) => props.theme.colors.neutral.n2};
  border-bottom: 1px solid ${(props) => props.theme.colors.neutral.n4};
  cursor: pointer;
`;

export const LinkTitle = styled.div<IProps>`
  width: 100%;
  font-size: ${(props) => props.theme.typography.fontSize.f7};
  line-height: 130%;
  font-weight: ${(props) => props.theme.typography.fontWeight.semiBold};
  color: ${(props) => props.theme.colors.black};
`;

export const LinkText = styled(Text)`
  width: 100%;
  font-size: ${(props) => props.theme.typography.fontSize.f5};
  line-height: 150%;
  letter-spacing: 0.02em;
  color: ${(props) => props.theme.colors.neutral.n8};
  text-transform: uppercase;
  margin-top: 4px;
`;

export const CoverImg = styled.div`
  width: 100%;
  height: auto;
`;

export const WheelMarkIconWrap = styled.div`
  width: 100%;

  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 55%,
    rgba(28, 31, 41, 0.2) 100%
  );
  background-color: ${(props) => props.theme.colors.neutral.n4};
`;

export const SocialActivityBlock = styled.div``;
